import { combineReducers } from 'redux'
import organizationsReducer from "./organizations/reducers/organizationsReducer";
import addEditBillingOrgReducer from "./organizations/reducers/AddEditOrgReducer";
import pricingTablesReducer from "./pricing-tables/reducers/pricingTablesReducer";
import AddEditPTReducer from "./pricing-tables/reducers/AddEditPTReducer";
import ManualEntryBillingRecordsReducer from "./manual-entry-billing-records/reducers/ManualEntryBillingRecordsReducer";
import AddEditBillingRecordsReducer from "./manual-entry-billing-records/reducers/AddEditBillingRecordsReducer";
import AddEditCountryPricingReducer from "./pricing-tables/reducers/AddEditCountryPricingReducer";
import BillingReportReducer from "./billing-reports/reducers/BillingReportReducer";

const billingRootReducer = combineReducers({
    organizations: organizationsReducer,
    addEditBillingOrg: addEditBillingOrgReducer,
    pricing: pricingTablesReducer,
    addEditPricingTable: AddEditPTReducer,
    addEditCountryPricing: AddEditCountryPricingReducer,
    manualEntryRecords: ManualEntryBillingRecordsReducer,
    addEditBillingRecords: AddEditBillingRecordsReducer,
    billingReportReducer: BillingReportReducer,
});

export default billingRootReducer;
